import magnifiAPIInstance from "./apiInstance";

export const workspaceAPIs = {
  getWorkspaceUsers: ({ payload }) => {
    const role = payload?.role && payload?.role !== "superadmin" ? `&role=${payload?.role}` : "";

    return magnifiAPIInstance.get(
      `/workspace/${payload?.workspaceId}/users?page=${payload?.page}&searchQuery=${payload?.search || ""}&pageSize=${payload?.pageSize}&fromDate=${payload?.fromDate || ""}&toDate=${payload?.toDate || ""}&roles=${payload?.roles || ""}${role}`,
      payload,
    );
  },
  getWorkspaceAssignableUsers: ({ entityId, page = 1, pageSize = 10, search = "" }) =>
    magnifiAPIInstance.get(
      `/workspace/${entityId}/users/assignable?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search ?? "")}`,
    ),
  createWorkspaceUser: ({ entityId, payload }) => magnifiAPIInstance.post(`/workspace/${entityId}/user`, payload),
  assignWorkspaceUser: ({ entityId, userId, payload }) =>
    magnifiAPIInstance.post(`/workspace/${entityId}/user/${userId}`, payload),
  updateWorkspaceMember: ({ workspaceMemberId, payload }) =>
    magnifiAPIInstance.put(`/workspace-member/${workspaceMemberId}`, payload),
  removeWorkspaceMember: ({ payload }) => magnifiAPIInstance.delete(`/workspace-member/${payload.workspaceMemberId}`),
  deleteWorkspace: ({ payload, workspaceId }) => magnifiAPIInstance.delete(`/workspace/${workspaceId}`, payload),
  getMeWorkspaces: ({ payload }) => magnifiAPIInstance.get(`/me/workspaces`, payload),
};
